var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 46,
    viewBox: "0 0 67 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.313477,
    y: 1.14966,
    width: 66.3704,
    height: 44.247,
    rx: 10.0561,
    fill: "url(#paint0_radial_41_595)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4985 1.5899L26.124 13.1531C26.124 13.1531 29.0738 23.2709 26.124 31.9433L33.4985 44.9519L40.873 31.9433C40.873 31.9433 37.9232 24.7163 40.873 13.1531C40.873 13.1531 33.4985 1.5899 33.4985 1.5899Z",
    stroke: "#C7C7B6",
    strokeWidth: 2.61459,
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.313477 13.6844H26.1242",
    stroke: "#C7C7B6",
    strokeWidth: 2.61459,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1357 13.6844H66.6839",
    stroke: "#C7C7B6",
    strokeWidth: 2.61459,
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.313477 31.3824H26.1242",
    stroke: "#C7C7B6",
    strokeWidth: 2.61459,
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1357 31.3823H66.6839",
    stroke: "#C7C7B6",
    strokeWidth: 2.61459,
    strokeLinejoin: "bevel"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_41_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-35.1132 28.1293 -42.1939 -23.4088 38.4269 17.2673)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDCDA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.e84708e71278f57ebf298cb0aa95e5c0.svg";
export { ForwardRef as ReactComponent };